module.exports = __webpack_public_path__ + "img/993821325.ed70df84.jpg";